import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, ArrowUpRight } from 'lucide-react';
import { QuickRakeback } from '../account/QuickRakeback';

export const OriginalsBar = ({ game, onAuth, gameBusy }) => {
  const title = game[0].toUpperCase() + game.slice(1);
  return <section className="originals-bar" data-testid="originals-game-bar" aria-label={`${title} Originals`}>
    <div className="originals-current"><h1 data-testid="originals-current-game">{title}</h1><span className="originals-bar-separator" aria-hidden="true" />
    <nav aria-label="Original games" data-testid="originals-game-links">
      <Link to="/originals" data-testid="originals-bar-gallery-link"><Gamepad2 size={17} aria-hidden="true" />Originals<ArrowUpRight size={15} aria-hidden="true" /></Link>
    </nav>
    </div>
    <QuickRakeback onAuth={onAuth} />
  </section>;
};